// extracted by mini-css-extract-plugin
module.exports = {"title":"title__1ES2X","attribute":"attribute__1Y32d","wrap":"wrap__DMwXM"};